import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const CATEGORIES = {
  plat_mijote: 'Plat mijoté',
  plat_four: 'Plat au four',
  poisson: 'Poisson',
  soupe: 'Soupe',
  tarte: 'Tarte / Pizza',
  pates_gratin: 'Pâtes / Gratin',
  sauce: 'Sauce',
  dessert: 'Dessert',
  autre: 'Autre'
};

export const INGREDIENT_CATEGORIES = {
  legumes: 'Légumes',
  viandes: 'Viandes',
  poissons: 'Poissons',
  feculents: 'Féculents',
  produits_laitiers: 'Produits laitiers',
  condiments: 'Condiments',
  epices: 'Épices',
  autres: 'Autres'
};

export const SEASONS = {
  printemps: 'Printemps',
  ete: 'Été',
  automne: 'Automne',
  hiver: 'Hiver',
  toutes: 'Toutes saisons'
};

export const UNITS = {
  g: 'grammes',
  kg: 'kilogrammes',
  ml: 'millilitres',
  l: 'litres',
  piece: 'pièce(s)',
  cuillere_cafe: 'cuillère(s) à café',
  cuillere_soupe: 'cuillère(s) à soupe'
};

export const FORMULAS = {
  petit: { name: 'Petit cocon', description: '1-2 personnes', price: 150 },
  moyen: { name: 'Cocon familial', description: '3-4 personnes', price: 200 },
  grand: { name: 'Cocon tribu', description: '5-6 personnes', price: 250 }
};

export const OPTIONS = {
  lunch: { name: 'Lunch', description: 'Repas supplémentaires pour le midi', price: 30 },
  dessert: { name: 'Dessert', description: 'Desserts maison', price: 25 },
  patisserie: { name: 'Pâtisserie', description: 'Gâteaux et pâtisseries', price: 35 }
};

export const PAYMENT_STATUS = {
  en_attente: { label: 'En attente', color: 'bg-yellow-100 text-yellow-800' },
  paye: { label: 'Payé', color: 'bg-green-100 text-green-800' },
  echec: { label: 'Échec', color: 'bg-red-100 text-red-800' },
  rembourse: { label: 'Remboursé', color: 'bg-gray-100 text-gray-800' },
  non_paye: { label: 'Non payé', color: 'bg-orange-100 text-orange-800' },
  test: { label: 'Test', color: 'bg-purple-100 text-purple-800' }
};

export const RESERVATION_STATUS = {
  en_attente: { label: 'En attente', color: 'bg-yellow-100 text-yellow-800' },
  confirmee: { label: 'Confirmée', color: 'bg-blue-100 text-blue-800' },
  en_cours: { label: 'En cours', color: 'bg-[#A5BBA8]/20 text-[#2A312C]' },
  terminee: { label: 'Terminée', color: 'bg-green-100 text-green-800' },
  annulee: { label: 'Annulée', color: 'bg-red-100 text-red-800' },
  expiree_paiement: { label: 'Expirée – paiement non finalisé', color: 'bg-orange-100 text-orange-800' }
};

export function getFormulaFromSize(size) {
  if (size <= 2) return 'petit';
  if (size <= 4) return 'moyen';
  return 'grand';
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('fr-FR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

export function formatPrice(amount) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount);
}
